import React, {useState} from 'react';
import {useLocation} from "react-router-dom";
import {Popover} from '@mui/material';
import {Images, useModal} from 'utils';
import {BulkAssignSignature, SignatureReminder} from './modals';
import {bulkSignTargetEnum, reminderTargetEnum} from './modals/constants';
import {ToolInfo} from "../../../components";

export const SignatureActionsMenu = ({selectedList, selectedFullList, selectAllList, afterSuccess}) => {
    const {open} = useModal();
    const [anchorEl, setAnchorEl] = useState(null);
    const isOpen = Boolean(anchorEl);
    const location = useLocation();
    const info = location?.state;
    const handleOpen = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const openReminder = (reminderType) => {
        handleClose();
        open(
            <SignatureReminder
                reminderType={reminderType}
                selectedList={selectedList}
                selectedFullList={selectedFullList}
                afterSuccess={afterSuccess}
            />
        );
    };

    const openBulkSign = (signatureType) => {
        handleClose();
        open(
            <BulkAssignSignature
                signatureType={signatureType}
                selectAllList={selectAllList}
                selectedFullList={selectedFullList}
                afterSuccess={afterSuccess}
            />
        );
    };

    const actions = [
        {text: 'Remind Client', icon: Images.notification, onClick: () => openReminder(reminderTargetEnum.CLIENT)},
        {
            text: 'Remind Provider',
            icon: Images.notification,
            onClick: () => openReminder(reminderTargetEnum.PROVIDER),
        },
        {
            text: 'Sign Provider',
            icon: Images.signIcon,
            onClick: () => openBulkSign(bulkSignTargetEnum.PROVIDER),
            disabled: info?.staffs?.length !== 1,
            disableText: 'At least one staff must been selected',
        },
        {
            text: 'Sign Guardian',
            icon: Images.signIcon,
            onClick: () => openBulkSign(bulkSignTargetEnum.GUARDIAN),
            disabled: info?.clients?.length !== 1,
            disableText: 'At least one client must been selected',
        },
    ];

    return (
        <>
            <button disabled={selectAllList} style={{opacity: selectAllList ? 0.5 : 1}} onClick={handleOpen}
                    className="select-all-btn">
                <img src={Images.signIcon} alt="signature actions"/>
                <img
                    style={{
                        transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                        filter: 'brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%) hue-rotate(134deg) brightness(103%) contrast(101%)',
                    }}
                    src={Images.dropdownArrow}
                    alt="upIcon"
                />
            </button>

            <Popover
                open={isOpen}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                transformOrigin={{vertical: 'bottom', horizontal: 'center'}}
                PaperProps={{sx: {minWidth: 190, marginTop: '-8px'}}}>
                <div className="more-actions-popover signature-sign-actions">
                    {actions?.map((action) => action && (
                        <button
                            className='space-between'
                            style={{opacity: action?.disabled ? 0.5 : 1}}
                            disabled={action?.disabled}
                            key={action.text}
                            onClick={action.onClick}
                        >
                            <div className="flex-align-center" style={{gap: 8}}>
                                <img src={action.icon} alt="icon"/>
                                <p>{action.text}</p>
                            </div>
                            {action?.disableText &&
                                <ToolInfo text={action?.disableText} iconStyle={{width: 14, marginTop: 4}} />
                            }
                        </button>
                    ))}
                </div>
            </Popover>
        </>
    );
};
